import React, { FunctionComponent } from 'react';

import CopyPage from './CopyPage';

export const TermsAndConditions: FunctionComponent = () => {
    return (
        <CopyPage name={'terms_conditions'} />
    )
}
export default TermsAndConditions